<template>
  <div v-if="registrationUrl" class="v2-registration-link">
    <div class="v2-registration-link__row">
      <label class="v2-registration-link__field">
        <span class="v2-registration-link__label">Registration link</span>
        <input
          ref="linkInput"
          type="text"
          :value="registrationUrl"
          readonly
          aria-label="Registration link"
          @focus="$event.target.select()"
        />
      </label>
      <button type="button" aria-label="Copy registration link" @click="copyLink">
        {{ copied ? 'Copied!' : 'Copy link' }}
      </button>
    </div>
    <p class="v2-registration-link__help" role="status" aria-live="polite">
      {{ copied ? 'Registration link copied.' : copyFailed ? 'Select and copy the registration link above.' : 'Share this link to open the signup form directly.' }}
    </p>
  </div>
</template>

<script>
import { copyTextToClipboard } from '../../../../composables/useCampaignShare'

export default {
  name: 'V2RegistrationLink',
  props: {
    campaignId: { type: [String, Number], required: true },
  },
  data() {
    return { copied: false, copyFailed: false }
  },
  computed: {
    registrationUrl() {
      const id = String(this.campaignId ?? '')
      if (!/^[1-9]\d*$/.test(id)) return ''
      const path = `/campaigns/${id}?register=1`
      // Use this environment and campaign, never an incidental pledge,
      // preview, tracking or modal parameter from the current address.
      return typeof window === 'undefined' ? path : `${window.location.origin}${path}`
    },
  },
  watch: {
    registrationUrl() {
      clearTimeout(this._copyTimer)
      this.copied = false
      this.copyFailed = false
    },
  },
  beforeUnmount() {
    clearTimeout(this._copyTimer)
  },
  methods: {
    async copyLink() {
      const url = this.registrationUrl
      const copied = await copyTextToClipboard(url, this.$refs.linkInput)
      if (this.registrationUrl !== url || this.$.isUnmounted) return
      this.copied = copied
      this.copyFailed = !copied
      clearTimeout(this._copyTimer)
      if (copied) this._copyTimer = setTimeout(() => { this.copied = false }, 2500)
    },
  },
}
</script>

<style scoped>
.v2-registration-link {
  width: 100%;
  min-width: 0;
  padding-top: 18px;
  margin-top: 18px;
  border-top: 1px solid #d6d9e2;
  font-family: 'Red Hat Text', system-ui, sans-serif;
  text-align: left;
}
.v2-registration-link__row { display: flex; align-items: flex-end; gap: 8px; min-width: 0; }
.v2-registration-link__field { display: flex; flex: 1; flex-direction: column; gap: 6px; min-width: 0; margin: 0; }
.v2-registration-link__label { color: var(--sideout-navy, #1d2549); font-size: 14px; font-weight: 700; line-height: 1.4; }
.v2-registration-link input {
  width: 100%;
  min-width: 0;
  height: 44px;
  padding: 10px 12px;
  border: 1px solid #bdc2c6;
  border-radius: 8px;
  background: #fff;
  color: var(--sideout-navy, #1d2549);
  font: 400 14px/1.4 'Red Hat Text', system-ui, sans-serif;
  text-overflow: ellipsis;
}
.v2-registration-link button {
  flex: 0 0 auto;
  min-height: 44px;
  padding: 10px 14px;
  border: 1px solid var(--sideout-pink, #da1884);
  border-radius: 8px;
  background: #fff;
  color: #a41263;
  font: 700 14px/1.4 'Red Hat Text', system-ui, sans-serif;
  white-space: nowrap;
  cursor: pointer;
}
.v2-registration-link button:hover { background: #fdf3f9; }
.v2-registration-link input:focus-visible,
.v2-registration-link button:focus-visible { outline: 3px solid #0075a7; outline-offset: 2px; }
.v2-registration-link__help { margin: 7px 0 0; color: #525d65; font-size: 12px; line-height: 1.5; }
@media (max-width: 480px) {
  .v2-registration-link input { font-size: 16px; }
  .v2-registration-link button { padding-inline: 10px; }
}
</style>
